import React from 'react';
import {ClientDocumentsPageV2} from '../ClientDocumentsPageV2/ClientDocumentsPageV2';
import {useDjangoContext} from '../../contexts/useAuthContext';
import {GlobalPermissionEnum} from '../../schema-types/globalTypes';
import {ClientDocumentsPageV1} from './ClientDocumentsPageV1';

export const ClientDocumentsPage: React.FC = () => {
  const {perms} = useDjangoContext();

  // TODO: remove this "feature" flag later
  if (perms.includes(GlobalPermissionEnum.can_access_document_upload_v2)) {
    return <ClientDocumentsPageV2 />;
  }

  return <ClientDocumentsPageV1 />;
};
